//@ts-check

import React from 'react';
import { ArrowLeft, ArrowRight } from 'react-feather';
import { Button, UncontrolledTooltip } from 'reactstrap';
import PropTypes from 'prop-types';
import { useTest, useUnit } from 'hooks/units/index';
import { useSelector } from 'react-redux';
import { getColor, getColorText } from 'store/settings';
import styled from '@emotion/styled';
import { FaRegQuestionCircle, FaRegBookmark, FaBookmark } from 'react-icons/fa';
import ThemeButton from 'components/AntdFormInputs/theme-button';

const ButtonAnswer = ({
  onSubmit,
  isLoading,
  availablePosition,
  bookmarked,
  setBookmarked,
  isLastValue,
  toggleBookmark,
  durationDisable,
}) => {
  const unitSelected = useUnit();
  const test = useTest();
  //Color Theme
  const colorStatus = useSelector(getColor);
  const colorTextStatus = useSelector(getColorText);
  const Stylescal = styled.div`
    .btn-danger {
      border-color: ${colorStatus} !important;
      background-color: ${colorStatus} !important;
      color: ${colorTextStatus} !important;
    }
    .btn-danger:hover {
      border-color: ${colorStatus} !important;
      background-color: #ffffff !important;
      color: ${colorStatus} !important;
    }
    .btn-danger:disabled {
      border-color: ${colorStatus} !important;
      background-color: ${colorStatus} !important;
      color: ${colorTextStatus} !important;
    }
    @media (max-width: 540px) {
    .btn-danger {
      padding: 6px 10px; 
      font-size: 12px !important; 
    }
  `;
  return (
    <div className="border border-grey rounded p-1 flexRow justify-space-between mt-2 align-items-center">
      <div className="d-flex align-items-center">
        <button
          onClick={() =>
            toggleBookmark(
              test?.current,
              // availablePosition.findIndex(
              //   (value) => value === parseInt(test?.current),
              // ) + 1,
            )
          }
          className="btn btn-light d-flex align-items-end round"
          disabled={isLoading || durationDisable}
          style={{
            color: 'black',
            backgroundColor: '#E8F5FE',
            cursor: durationDisable ? 'not-allowed' : 'pointer',
          }}
        >
          <span style={{ marginRight: 3 }}>
            {bookmarked[test?.current] ? (
              <FaBookmark color="gold" />
            ) : (
              <FaRegBookmark color="grey" />
            )}
          </span>
          Add to bookmark
        </button>
      </div>
      <h3 className="mb-0 content-question-font">
        Question{' '}
        {availablePosition?.findIndex(
          (value) => value === parseInt(test?.current),
        ) + 1}{' '}
        of {availablePosition.length}
      </h3>
      <div className="d-flex align-items-center">
        {test?.behavior?.nextQuestion && test?.current > 1 && (
          <>
            <span
              onClick={() =>
                onSubmit({
                  isSkip: true,
                  isNext: false,
                })
              }
              className="cursor-pointer mr-1"
            >
              <ArrowLeft id="previousQuestion" />
            </span>
            <UncontrolledTooltip placement="bottom" target="previousQuestion">
              Previous question
            </UncontrolledTooltip>
          </>
        )}

        {unitSelected?.config?.completion?.previewBefore === 'BEFORE' &&
        isLastValue ? (
          <ThemeButton
            className="round"
            padding="8px 16px"
            onClick={() => onSubmit('', 'review')}
          >
            Submit
          </ThemeButton>
        ) : (
          <Stylescal>
            <Button
              className="btn-danger round"
              disabled={isLoading}
              onClick={() => onSubmit({ status: 'review' })}
            >
              Submit
            </Button>
            {/* <Button
              className="btn-danger round"
              disabled={isLoading}
              onClick={() =>
                onSubmit(
                  unitSelected?.config?.completion?.enableButton ||
                    durationDisable
                    ? { autoSubmit: true, isSubmit: true, status: 'review' }
                    : isLastValue
                    ? { status: 'review' }
                    : undefined,
                )
              }
            >
              {unitSelected?.config?.completion?.enableButton || durationDisable
                ? 'Submit Test'
                : test?.current === test?.total
                ? 'Submit Test'
                : 'Submit'}
            </Button> */}
            {/* <Button
        className="btn-danger round"
        disabled={isLoading}
        onClick={() => onSubmit()}
      >
        {test?.current === test?.total ? 'Submit Test' : 'Submit Answer'}
      </Button> */}
            {/* <Button
      className="btn-danger round ml-1"
      disabled={isLoading}
      onClick={() => onSubmit('', '', '', true)}
    >
      Save Draft
    </Button> */}
          </Stylescal>
        )}

        {test?.behavior?.nextQuestion && test?.current < test.total && (
          <>
            <span
              className="cursor-pointer ml-1"
              onClick={() =>
                onSubmit({
                  isSkip: true,
                  isNext: true,
                })
              }
            >
              <ArrowRight id="nextQuestion" />
            </span>
            <UncontrolledTooltip placement="bottom" target="nextQuestion">
              Next question
            </UncontrolledTooltip>
          </>
        )}
      </div>
    </div>
  );
};

ButtonAnswer.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  isLoading: PropTypes.bool.isRequired,
};

export default ButtonAnswer;
